<template>
  <div class="chat-item">
    <div class="question-box">
      <div class="question-msg" :class="[options.size]">
        {{ chatItem.question_message }}
      </div>
    </div>
    <div class="answer-box">
      <div class="avatar-box" v-if="!hideChatAvatar">
        <div v-if="[0, 1].includes(chatItem.status)" class="icon-loading"></div>
        <img
          v-else
          class="avatar"
          src="https://o.666visa.cn/static/ssqpeer/chatvisa/icon-avatar.png"
          alt=""
        />
      </div>
      <div class="answer-body" :class="[options.size]">
        <div class="answer-message">
          <chat-item-answer-message
            :text="answerMessage"
            :key="refreshTime"
            :default-index="defaultIndex"
            :status="chatItem.status"
            :options="options"
          ></chat-item-answer-message>
        </div>
        <div v-if="chatItem.status === 3" class="stop-generate">
          （已停止生成）
        </div>
        <div class="answer-loading" v-if="[0, 1].includes(chatItem.status)">
          <div class="dot-1"></div>
          <div class="dot-2"></div>
          <div class="dot-3"></div>
        </div>
        <div class="answer-footer" :class="[options.size]" v-if="isAnswerSuccess">
          <div class="left-box" :class="[options.size]" @click="onRegenerate">
            <div v-if="isLast" class="link-btn regenerate">
              <div class="icon"></div>
              <div class="text">重新生成</div>
            </div>
          </div>
          <div class="right-box" :class="[options.size]">
            <base-popover content="复制">
              <div class="link-btn copy" @click="onCopy">
                <div class="icon"></div>
              </div>
            </base-popover>
            <base-popover content="点赞">
              <div
                class="link-btn good"
                :class="{ active: chatItem.review_status === 2 }"
                @click="changeReviewStatus(2)"
              >
                <div class="icon"></div>
              </div>
            </base-popover>
            <base-popover content="点踩">
              <div
                class="link-btn bad"
                :class="{ active: chatItem.review_status === 1 }"
                @click="changeReviewStatus(1)"
              >
                <div class="icon"></div>
              </div>
            </base-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '../../../libs/http';
import utils from '../../../libs/utils';
import ChatItemAnswerMessage from './chat-item-answer-message.vue';
import BasePopover from '../../../components/common/popover/base-popover.vue';
import sensorsdata from 'sa-sdk-javascript';

export default {
  components: {
    ChatItemAnswerMessage,
    BasePopover,
  },
  props: {
    chatItem: Object,
    isLast: Boolean,
    hideChatAvatar: Boolean,
    /**
     * hidePageBody: 隐藏body
     * hidePageFooterHandle：隐藏底部操作
     * hidePageFooterTips： 隐藏底部提示
     * bodyWidth：body的宽度
     * background： 背景色
     * hideChatAvatar: 隐藏聊天头像
     * size: 大小，small 代表小尺寸显示模式
     * sensorData: 埋点数据
     */
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      timer: null,
      defaultIndex: 0, // 当前默认的index,也就是这部分不会走打字机动画
      refreshTime: undefined, // 用于强制刷新打字机组件，
    };
  },
  computed: {
    // 是否生成成功，状态成功了，还需要有文案，否则也算失败
    isAnswerSuccess() {
      if ([0, 1].includes(this.chatItem.status)) {
        return false;
      }
      return this.chatItem.answer_message;
    },
    answerMessage() {
      if (
        [2, 4].includes(this.chatItem.status) &&
        !this.chatItem.answer_message
      ) {
        // 不是生成中，然后没有答案，这个时候要走默认文案
        return '很抱歉，这个问题暂无法回答，您可以尝试重新提问或联系签证专家';
      }
      return this.chatItem.answer_message;
    },
  },
  watch: {
    chatItem: {
      handler() {
        // 状态变了，停止查询
        if (![0, 1].includes(this.chatItem.status)) {
          this.stopPolling();
        }
      },
      deep: true,
    },
  },
  created() {
    this.init();
  },
  destroyed() {
    this.stopPolling();
  },

  methods: {
    init() {
      if ([0, 1].includes(this.chatItem.status)) {
        // 待生成、生成中，轮询
        this.pollingQueryAnswer();
      }
      this.defaultIndex = this.chatItem.answer_message
        ? this.chatItem.answer_message.length
        : 0;
      this.refreshTime = new Date().getTime();
    },
    async pollingQueryAnswer() {
      const res = await Http.post('/chatvisa_record_answer_query', {
        chatvisa_record_id: this.chatItem.chatvisa_record_id,
      });
      this.$emit('update', {
        answer_message: res.answer_message,
        status: res.status,
      });
      if ([0, 1].includes(res.status)) {
        // 待生成、生成中，继续查询
        this.timer = setTimeout(() => {
          this.pollingQueryAnswer();
        }, 1000);
      }
    },
    stopPolling() {
      if (!this.timer) return;
      clearTimeout(this.timer);
      this.timer = null;
    },
    async changeReviewStatus(status) {
      const review_status = status === this.chatItem.review_status ? 0 : status;
      await Http.post('/chatvisa_record_review', {
        chatvisa_record_id: this.chatItem.chatvisa_record_id,
        review_status,
      });

      if (review_status) {
        sensorsdata.track('qw_feedback_click', {
          feedback_type: review_status === 1 ? 'dislike' : 'like',
          ...this.options.sensorsData,
        });
        this.$message.success('感谢反馈');
      }
      this.$emit('update', {
        review_status,
      });
    },
    onCopy() {
      sensorsdata.track('qw_feedback_click', {
        feedback_type: 'copy',
        ...this.options.sensorsData,
      });
      utils.copyText(this.chatItem.answer_message);
      this.$message.success('复制成功');
    },
    // 重新生成
    async onRegenerate() {
      sensorsdata.track('qw_feedback_click', {
        feedback_type: 'retry',
        ...this.options.sensorsData,
      });
      await Http.post('/chatvisa_record_recreate', {
        chatvisa_record_id: this.chatItem.chatvisa_record_id,
      });
      this.$emit('update', {
        review_status: 0,
        answer_message: '',
        status: 0,
      });
      this.init();
    },
  },
};
</script>

<style lang="less" scoped>
.chat-item {
  width: 100%;
  margin-top: 32px;
  .question-box {
    display: flex;
    justify-content: flex-end;
    .question-msg {
      max-width: 550px;
      border-radius: 12px;
      background: rgba(107, 158, 248, 0.25);
      // white-space: pre-wrap;
      word-break: break-all;
      padding: 20px;
    }
    .small {
      padding: 12px;
      border-radius: 4px;
      max-width: 300px;
      line-height: 24px;
    }
  }
  .answer-box {
    margin-top: 32px;
    display: flex;
    align-items: flex-start;
    position: relative;
    .avatar-box {
      position: absolute;
      right: 100%;
      margin-top: 12px;
      margin-right: 12px;
      top: 0;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: linear-gradient(224deg, #8765ff 0%, #6facff 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      .icon-loading {
        width: 18px;
        height: 18px;
        animation: spin 1s linear infinite;
        border: 3px solid rgba(255, 255, 255, 0.3);
        border-top: 3px solid #fff;
        border-radius: 50%;
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      }
      .avatar {
        width: 23px;
        height: 23px;
      }
    }
    .answer-body {
      box-shadow: 0px 3px 16px 0px rgba(30, 43, 61, 0.12);
      background: #fff;
      flex-grow: 1;
      overflow: hidden;
      padding: 20px;
      border-radius: 12px;
      &.small {
        width: 336px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e9eef2;
        box-shadow: none;
        padding: 12px;
      }
      .answer-message {
        width: 100%;
      }
      .stop-generate {
        color: #91999f;
        font-size: 14px;
      }
      .answer-loading {
        height: 24px;
        display: flex;
        align-items: center;
        gap: 4px;
        .dot-1,
        .dot-2,
        .dot-3 {
          background: #2f333d;
          animation: dotAnimation 0.5s infinite alternate;
          animation-delay: 0;
          width: 4px;
          height: 4px;
          border-radius: 50%;
        }
        .dot-2 {
          animation-delay: 0.25s;
        }
        .dot-3 {
          animation-delay: 0.5s;
        }
        @keyframes dotAnimation {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.4;
          }
        }
      }
      .answer-footer {
        margin-top: 20px;
        display: flex;
        &.small{
          margin-top: 12px;
        }
        justify-content: space-between;
        .left-box,
        .right-box {
          display: flex;
          align-items: center;
          gap: 20px;

          &.small {
            .icon {
              width: 16px;
              height: 16px;
            }
            .text {
              margin-left: 4px;
              color: #91999f;
              font-size: 12px;
              line-height: 1;
            }
          }
        }
        .link-btn {
          display: flex;
          align-items: center;
          cursor: pointer;
          .icon {
            width: 20px;
            height: 20px;
          }
          .text {
            margin-left: 4px;
            color: #91999f;
            font-size: 14px;
            line-height: 1;
          }
          &.good {
            .icon {
              background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-good.png)
                no-repeat center / 100% 100%;
            }
          }
          &.bad {
            .icon {
              background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-bad.png)
                no-repeat center / 100% 100%;
            }
          }
          &.copy {
            .icon {
              background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-copy.png)
                no-repeat center / 100% 100%;
            }
          }
          &.regenerate {
            .icon {
              background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-regenerate.png)
                no-repeat center / 100% 100%;
            }
          }
          &.active {
            &.good {
              .icon {
                background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-good-active.png)
                  no-repeat center / 100% 100%;
              }
            }
            &.bad {
              .icon {
                background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-bad-active.png)
                  no-repeat center / 100% 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/components/chat-item.vue